// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"8a88a4d3","234":"24f3e0cd","555":"1b0bfa1a"}[chunkId] + ".chunk.css";
};